
    import * as React from 'react';

    const Prev16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M6.87 12.49l-.515.51L1 8l5.355-5 .516.51-4.427 4.134H15v.712H2.444z" /></svg>
        </div>
      );
    };

    Prev16.displayName = 'Prev16';

    export default Prev16;
  